import axios from 'axios'

const baseURL = process.env.VUE_APP_NOTARNET_ROUTE
const loginString = process.env.VUE_APP_NOTARNET_LOGIN_STRING
const user = process.env.VUE_APP_NOTARNET_USER
const folder = process.env.VUE_APP_NOTARNET_FOLDER
const name = process.env.VUE_APP_NOTARNET_NAME
const certificate = process.env.VUE_APP_NOTARNET_CERTIFICATE

const ROUTES = {
  login: '/login',
  signDocument: '/api/signcertified',
}

const notarnetClient = axios.create({
  baseURL
})

let isAuthenticating = false
notarnetClient.interceptors.response.use(
  response => response, 
  error => {
    if (error.response.data.Message === 'El token de la sesión ha expirado.' && !isAuthenticating) {
      const originalRequestConfig = error.config
      isAuthenticating = true

      notarnet.login()
        .then(() => {
          originalRequestConfig.headers.Authorization = localStorage.getItem('notarnetToken')
          isAuthenticating = false
          return notarnetClient.request(originalRequestConfig)
        })
    }
    return error
  }
)

export const notarnet = {
  login: () => {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded"
    }

    return new Promise((resolve, reject) => {
      notarnetClient.post(ROUTES.login, loginString, { headers })
      .then(res => {
        /* 
        TODO: Considerar localStorage vs HTTP-only cookie cuidadosamente. Ambas tienen vulnerabilidades.
        https://stackoverflow.com/questions/26340275/where-to-save-a-jwt-in-a-browser-based-application-and-how-to-use-it/40376819#40376819
        */
        localStorage.setItem('notarnetToken', `Inmatic ${res.data.auth_token}`)
        resolve(res)
      })
      .catch(err => reject(err))
    })
  },

  signDocument: document => {
    const data = new FormData()
    data.append('file', document)
    data.append('user', user)
    data.append('folder', folder)
    data.append('name', name)
    data.append('certificate', certificate)
    data.append('creartif', 'true')

    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': localStorage.getItem('notarnetToken'),
    }

    return new Promise((resolve, reject) => {
      notarnetClient.post(ROUTES.signDocument, data, { headers })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  }

}